import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { SectorTypeService } from 'src/app/shared/API-Service/services/sector-type.service';
import { SectorService } from 'src/app/shared/API-Service/services/sector.service';
import { timestamp } from 'rxjs/operators';


@Component({
  selector: 'app-insert-sector-type',
  templateUrl: './insert-sector-type.component.html',
  styleUrls: ['./insert-sector-type.component.css']
})
export class InsertSectorTypeComponent implements OnInit {
  recordtoupdate:any;
sectorid:any;
sectortypeForm:FormGroup ;
update:boolean = false;
button:boolean = false;
  constructor(private _SectorTypeService:SectorTypeService,private _Router:Router,private _FormBuilder:FormBuilder,private _SectorService:SectorService) { }

  ngOnInit(): void {
    this.getsectorid();
    this.initiate();
    this.checkEdit();
  }
getsectorid(){
  this._SectorService.GetSector().subscribe((res) => {
    this.sectorid = res.data;
  },(err) => {
    console.log('their is a problem ');
  },() => {
    console.log('completed');
  })
}
initiate(){
  this.sectortypeForm = this._FormBuilder.group({
    title: ['', Validators.required],
    numberofDays: ['', Validators.required],
    sectorId: ['', Validators.required],
  });
}
get fc() {
  return this.sectortypeForm.controls;
}

checkEdit() {
  this._SectorTypeService.Data.subscribe((res) => {
    if (res != null) {
      this.sectortypeForm = this._FormBuilder.group({
        title: [res.title, Validators.required],
        numberofDays: [res.numberofDays, Validators.required],
         sectorId: [res.sectorId, Validators.required],
      });
      
      this.update = true;
      this.recordtoupdate = res ;
    
    } else {
      console.log(`not found on data`);
      // this.initiate();
    }
   
  });
}

onSubmit(){
  this.button = true;
 if(this.update == false && this.sectortypeForm.status == "VALID"){

  this._SectorTypeService.CreateSectorType(this.sectortypeForm.value).subscribe((res) => {
    Swal.fire({
      icon: "success",
      title: "تم التسجيل بنجاح",
      showConfirmButton: false,
      timer: 1500,
    });
    this.sectortypeForm.reset();
    this._Router.navigate(['/content/admin/ViewSectorType']);
  },(err) => {
    Swal.fire({
      icon: 'error',
      title: 'خطا',
      text:err.message    
    }) 
    this.button = false ;
  }, () => {
    console.log('completed ');
  })
 } else if(this.sectortypeForm.status == "VALID"){
  this.sectortypeForm.addControl('id', new FormControl(this.recordtoupdate.id, Validators.required));
  this._SectorTypeService.UpdateSectorType(this.sectortypeForm.value).subscribe((res) => {
    Swal.fire({
      icon: "success",
      title: "تم التعديل بنجاح",
      showConfirmButton: false,
      timer: 1500,
    });
    this.sectortypeForm.reset();
    this._Router.navigate(['/content/admin/ViewSectorType']);
  },(err) => {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:err.message    
    }) 
  }, () => {
    console.log('completed ');
  })
 }else {
  Swal.fire({
    icon: 'error',
    title: 'خطأ',
    text:"بالرجاء التأكد من ملئ جميع الحقول"   
  })
  this.sectortypeForm.markAllAsTouched();
  this.button = false;
 }
}


ngOnDestroy(){
  this._SectorTypeService.Data.next(null);
   }


}
